import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import {
  addPlaylist,
  clonePlaylist,
  bulkUpdateRequest,
  playlistUpdateTagsRequest,
  confirmationRequest,
  fetchPlaylists,
  filterPlaylistByTag,
  setPageTitle,
  fetchPagedPlayists,
  bulkDeletePlaylist,
  bulkUpdatePlaylist,
  fetchTags,
  setPlaylistTags,
  addTag,
  addUserReport,
  fetchAssets,
} from "../../actions";

import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom/es";
import "./styles.scss";
import "react-table-v6/react-table.css";
import selectTableHOC from "react-table/lib/hoc/selectTable";
import PropTypes from "prop-types";
import Table from "react-table";
import "react-table-v6/react-table.css";
import { actions as notifActions } from "redux-notifications";
import {
  searchPlaylists,
  updateImageAsset,
  updateVideoAsset,
  updateAudioAsset,
} from "signoxe/actions";
import { Page } from "../../components";
import { EmptyMessage } from "signoxe/components/widgets";
import { searchStrFromRouterLocation } from "signoxe/utils/router";

import { SearchFilterBar } from "../../components/widgets";
import {
  getPlaylists,
  getPlaylistPreloadState,
  isFetchingAssests,
  getTagsAll,
  getProfile,
  getFilteredAssetsByQuery,
} from "../../selectors";

import AssetListChecker from "signoxe/components/AssetsListChecker";
class AssetCheckerPage extends React.Component {
  static defaultProps = {
    keyField: "id",
  };

  static propTypes = {
    assets: PropTypes.array.isRequired,
    isFetching: PropTypes.bool.isRequired,
    fetchAssets: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      show: false,
    };
  }

  componentDidMount() {
    this.props.setPageTitle("Asset Management");

    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  onToggleEdit = () => {
    this.setState({ show: !this.state.show });
  };

  handleUpdateAsset = (id, type, value) => {
    console.log("id, ", id, type, value);
    if (value.length) {
      if (type === "IMAGE") {
        this.props.updateImageAsset(id, { status: value });
      } else if (type === "VIDEO") {
        this.props.updateVideoAsset(id, { status: value });
      } else if (type === "AUDIO") {
        this.props.updateAudioAsset(id, { status: value });
      }
    }
  };

  handleSearch = (searchValue) => {
    this.props.history.replace({
      search: `?search=${searchValue}`,
    });
  };

  handleGoBack = () => {
    this.props.history.push('/assets')
  }
  
 
  // ensure user has the feature beofre  viewing the page
  
  render() {

    if(this.props.profile && this.props.profile.maker_checker == false){
      this.props.history.push('/assets')
    }
    const isMaker = this.props.profile && this.props.profile.is_maker

    const { show } = this.state;

    return (
      <Page>
        <div className="flex flex-dc">
          <div className="flex flex-jc-sb hide-for-mobile">
            <div className="cursor mb-1" onClick={this.handleGoBack}>
            <i class="fas fa-arrow-left fa-2x"></i>
            </div>
            <div></div>
          </div>
          <div class="flex flex-dc">
            <div className="flex flex-jc-sb mb-3">
              <SearchFilterBar
                className="input-group-2"
                placeholder="Search Assets"
                queryString={this.props.searchString}
                onQueryChange={this.handleSearch}
              />

              <div className="hide-for-mobile">
                {this.props.assets.length != 0 && (
                  <button
                    className={show ? "button btn-bg" : "button"}
                    onClick={this.onToggleEdit}
                  >
                    <i
                      class={
                        show
                          ? "fas fa-toggle-on mr-1"
                          : "fas fa-toggle-off mr-1"
                      }
                    ></i>
                    Show thumbnails{" "}
                  </button>
                )}
              </div>
            </div>

            {!this.props.isFetching && this.props.assets.length === 0 ? (
              <EmptyMessage text="No Assets yet for your review!" />
            ) : (
              <AssetListChecker
                isDisabled={isMaker}
                assets={this.props.assets}
                handleUpdateAsset={this.handleUpdateAsset}
                showthumbnails={show}
                isLoading={this.props.isFetching}
              />
            )}
          </div>
        </div>
      </Page>
    );
  }
}

export default connect(
  (state, props) => {
    const searchString = searchStrFromRouterLocation(props.location);
    return {
      searchString,
      assets: getFilteredAssetsByQuery(state, searchString),
      tags: getTagsAll(state),
      playlists: getPlaylists(state),
      next: getPlaylistPreloadState(state),
      isFetching: isFetchingAssests(state),
      profile: getProfile(state),
    };
  },
  {
    fetchAssets,
    updateImageAsset,
    updateAudioAsset,
    updateVideoAsset,
    setPageTitle,
  }
)(AssetCheckerPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/AssetCheckerPage/index.js